module.exports = __webpack_public_path__ + "img/share-email-2-bg.b70d07aa.png";